import type { DrawingCanvasShapeStyleBase } from '../types';

export const defaultLineWidth = 2;
export const bboxLineWidth = 1;
export const highlightRingWidth = 6;
export const hitRegionBuffer = highlightRingWidth * 2;
export const defaultLineJoin = 'round';

/** Reads a color design token from the page's stylesheet. */
const getColorToken = (ctx: CanvasRenderingContext2D, token: string): string =>
  getComputedStyle(ctx.canvas).getPropertyValue(token);

export const defaultStrokeColor = (ctx: CanvasRenderingContext2D) => getColorToken(ctx, '--color-foreground');
export const defaultFillColor = (ctx: CanvasRenderingContext2D) => getColorToken(ctx, '--color-white');
export const highlightRingColor = (ctx: CanvasRenderingContext2D) => getColorToken(ctx, '--color-blue-40');
export const selectedFillColor = (ctx: CanvasRenderingContext2D) => getColorToken(ctx, '--color-blue-50');

/** Strokes the current path as a highlight ring around the shape's stroke */
export const strokeHighlight = (ctx: CanvasRenderingContext2D, style?: DrawingCanvasShapeStyleBase): void => {
  ctx.save();
  ctx.lineWidth = (style?.lineWidth ?? defaultLineWidth) + highlightRingWidth;
  ctx.strokeStyle = highlightRingColor(ctx);
  ctx.stroke();
  ctx.restore();
};
